import React from 'react'
import ModalContratos from './ModalContratos'
import { useContractModal } from '../../contexts/ContractModalContext'

const GlobalContractModal: React.FC = () => {
  const { 
    isModalOpen, 
    clienteId, 
    planos, 
    closeModal, 
    onContractCreated, 
    onEditContract 
  } = useContractModal()

  if (!isModalOpen || !clienteId) {
    return null
  }


  return (
    <ModalContratos
      isOpen={isModalOpen}
      onClose={closeModal}
      clienteId={clienteId}
      planos={planos}
      onContractCreated={onContractCreated || (() => {})}
      onEditContract={onEditContract || (() => {})}
    />
  )
}

export default GlobalContractModal
